import { useRouter } from 'next/navigation';
import Button from '../common/Button';

interface Props {
  content: string;
  buttonText: string;
  buttonLink: string;
}

export const BannerWithCTA = ({ content, buttonText, buttonLink }: Props) => {
  const router = useRouter();

  return (
    <div className='h-min-16 mx-auto flex w-full flex-row items-center justify-center gap-4 pb-6'>
      <div className='h-min-14 text-md mx-6 rounded-2xl bg-gradient-to-tr from-purple-500 via-red-500 to-yellow-500 p-1 text-center font-bold text-gray-600 md:mx-0 md:rounded-full md:p-[2px] md:text-xl'>
        <div className='flex flex-col items-center justify-center rounded-xl bg-white p-2 md:flex-row md:rounded-full md:pl-4 md:pr-2'>
          <p className='text-center'>{content}</p>
          <Button
            className='pill-button mt-4 md:ml-4 md:mt-0'
            title={buttonText}
            onClick={() => router.push(buttonLink)}
          >
            {buttonText}
          </Button>
        </div>
      </div>
    </div>
  );
};
